import { Routes } from '@angular/router';

// Components:
import { HomeComponent } from './components/home/home.component';

export const ROUTES: Routes = [
  {
    path: 'banking',
    component: HomeComponent
  }
];
